// removed by extract-text-webpack-plugin
module.exports = {"menu":"_31xPv5xCvjJJ4KARuF1IxU","active":"W4_7rIL_RJNnbxXBGGBYg","icon":"_1ilFxC94aWWKxXQy8LnAqW","menuFix":"EXvLw8IkENFDjbavos9D9","flexHeight":"_3gK1nWxLnEsjxs3S_VjWcZ","menuHamburger":"LhiFPMdrkZ7Qa1XpoRjMC","responsiveMenu":"_2Ti1pMjha57IpL2IjhgvT5"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Profile/Pages/Config/style.css
// module id = 485
// module chunks = 38